import axiosInterceptors from "./axiosInterceptors";

const service = axiosInterceptors;

export default service;